module.exports = __webpack_public_path__ + "img/MSPNG3_Cover.b6a18954.jpg";